import React, { useState, useEffect } from "react";
// import Loginimg from "../../assets/images/login-img.png";
import Loginimg from "../../assets/images/newLog.png";
// import Loginimg from "../../assets/images/login-img3.png";
// import Loginimg from "../../assets/images/login-img3.png";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { toast, Bounce } from "react-toastify";
import { baseUrl } from "../../config/baseUrl";
// import logo from "../../assets/images/head-logo.png";
import toastify from "../../config/toastify";

// export default function Login() {
//   let navigate = useNavigate();
//   let token = localStorage.getItem("token");
//   const [showPass, setshowPass] = useState(false);

//   useEffect(() => {
//     localStorage.clear();
//     if (token != null) {
//       navigate("/");
//     }
//   });

//   let [formval, setFormval] = useState({ username: "", password: "" });
//   let ChangeHandler = (e) => {
//     setFormval((currVal) => {
//       return { ...currVal, [e.target.name]: e.target.value };
//     });
//   };

//   let handleSubmit = async (e) => {
//     e.preventDefault();
//     // console.log(formval);
//     if (!formval.username || !formval.password) {
//       return alert("all fileds is required");
//     }
//     formval.email = formval.username;
//     try {
//       const response = await axios(`${baseUrl}/mobile/login`, {
//         // const response = await axios(`${baseUrl}/api/v1/admin/login`, {
//         method: "POST",
//         data: {
//           email: formval.username,
//           password: formval.password,
//         },
//       });
//       console.log(response);

//       if (response?.status === 200) {
//         localStorage.setItem("token", response?.data?.token);
//         localStorage.setItem("user", JSON.stringify(response?.data?.user));
//         // console.log(response);
//         navigate("/");

//         toast.success(response?.data.message, {
//           position: "top-right",
//           autoClose: 1000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "light",
//           transition: Bounce,
//         });
//       } else {
//         // ToastMessgae(response?.data);

//         toastify.error(response.data.message);
//       }
//     } catch (error) {
//       console.log("Error :", error);
//       toast.error(`Something Went Wrong..!, Please Contact Developer Team`, {
//         position: "top-right",
//         autoClose: 5000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "light",
//         transition: Bounce,
//       });
//       // alert("Something Went Wrong..! , Please Contact Developer Team")
//     }
//   };

//   return (
//     <>
//       <section className="main-login">
//         <div className="container-fluid">
//           <div className="row">
//             <div
//               className="col-xl-6 b-center bg-size d-none d-lg-block d-xl-block"
//               style={{
//                 backgroundImage: `url(${Loginimg})`,
//                 backgroundSize: "cover",
//                 backgroundPosition: "center center",
//                 display: "block",
//               }}
//             >
//               <div className="login-lft">
//                 <img className="" src="/logo.png" alt="JewelDesk" />
//               </div>
//             </div>
//             <div className="col-xl-6 p-0">
//               <div className="login-card">
//                 <form action="" onSubmit={handleSubmit} className="login-form">
//                   <h4>
//                     <span>Login</span>
//                   </h4>
//                   <div className="mb-4 frm-bx">
//                     <label htmlFor="" className="form-label">
//                       User Name/Mobile Number
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="username"
//                       onChange={ChangeHandler}
//                       placeholder="UserName"
//                       value={formval.username}
//                     />
//                     <span className="fa fa-user" />
//                   </div>
//                   <div className="mb-3 frm-bx">
//                     <label htmlFor="" className="form-label">
//                       Password
//                     </label>
//                     <input
//                       type={showPass ? "text" : "password"}
//                       className="form-control"
//                       name="password"
//                       onChange={ChangeHandler}
//                       placeholder="Password"
//                       value={formval.password}
//                     />
//                     {showPass ? (
//                       <span
//                         className="fa fa-eye-slash"
//                         onClick={() => setshowPass(!showPass)}
//                       />
//                     ) : (
//                       <span
//                         className="fa fa-eye"
//                         onClick={() => setshowPass(!showPass)}
//                       />
//                     )}
//                   </div>
//                   {/* <div className=" text-end">
//                     <Link to="/forget-password">
//                       <b> Forgot Password </b>
//                     </Link>
//                   </div> */}
//                   <div className="mb-4 mt-5 frm-bx">
//                     <button className="frm-btn w-100" type="submit">
//                       Login
//                     </button>
//                   </div>
//                   {/* <div className="mb-4 mt-5 frm-bx">
//                     <button className=" w-100  btn btn-warning" type="submit">
//                       Forget Password
//                     </button>
//                   </div> */}
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// }

// import React, { useState, useEffect } from "react";

export default function Login() {

  let navigate = useNavigate();
  let token = localStorage.getItem("token");

  const [formval, setFormval] = useState({ username: "", password: "" });

  
  useEffect(() => {
    localStorage.clear();
    if (token != null) {
      navigate("/");
    }
  });

  const ChangeHandler = (e) => {
    setFormval((currVal) => {
      return { ...currVal, [e.target.name]: e.target.value };
    });
  };
  
  let handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(formval);
    if (!formval.username || !formval.password) {
      return alert("all fileds is required");
    }

    //static
    let password = "Admin@123";
    if (formval.password !== password) {
      toast.error("Password is Wrong!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      return;
    }

    formval.email = formval.username;
    try {
        const response = await axios(
          // `http://localhost:3009/admin/login`, {
          `${baseUrl}/admin/login`, {
        method: "POST",
        data: {
          email: formval.username,
        },
      });
      // console.log(response);

      if (response?.data.status) {
        localStorage.setItem("token", response?.data?.token);
        localStorage.setItem("user", JSON.stringify(response?.data?.data));
        // console.log(response);
        navigate("/");

        toast.success(response?.data.message, {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      } else {
        toastify.error(response.data.message);
      }
    } catch (error) {
      console.log("Error :", error);
      toast.error(`${error.response?.data?.message}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };
  return (
    <>
      <div className="login-container">
        <div className="left-section">
          <div className="animated-bg"></div>
          <div className="overlay-bg"></div>

          <div className="floating-element floating-1"></div>
          <div className="floating-element floating-2"></div>
          <div className="floating-element floating-3"></div>

          <div className="left-content">
            <div>
              <div className="logo-container">
                <img
                  src="appicon.png"
                  alt="Vaishnav Samaj"
                  className="logo-img"
                />
              </div>

              <h1 className="company-title">Vaishnav Samaj</h1>

              {/* <p className="tagline">
                Empowering livestock management with cutting-edge technology and
                care
              </p> */}

              <div className="decorative-line"></div>
            </div>
          </div>
        </div>

        <div className="right-section">
          <div className="form-container">
            <div className="mobile-logo">
              <img
                src="appicon.png"
                alt="Vaishnav Samaj"
                className="mobile-logo-img"
              />
              <h1 className="mobile-title">Vaishnav Samaj</h1>
            </div>

            <div className="login-card">
              <div className="card-header">
                <h3 className="welcome-title">Welcome Back</h3>
                <div className="header-line"></div>
                <p className="welcome-subtitle">Sign in to your account</p>
              </div>

              <div className="form-fields">
                <div className="field-container">
                  <label className="field-label">User Name/Email Address</label>
                  <div className="input-wrapper">
                    <input
                      type="text"
                      name="username"
                      value={formval.username}
                      onChange={ChangeHandler}
                      placeholder="Enter your username"
                      className="form-input"
                      required
                    />
                    <div className="input-icon user-icon"></div>
                  </div>
                </div>

                <div className="field-container">
                  <label className="field-label">Password</label>
                  <div className="input-wrapper">
                    <input
                      type="password"
                      name="password"
                      value={formval.password}
                      onChange={ChangeHandler}
                      placeholder="Enter your password"
                      className="form-input password-input"
                      required
                    />
                    <div className="input-icon lock-icon"></div>
                    {/* <button
                      type="button"
                      onClick={() => setshowPass(!showPass)}
                      className="toggle-password"
                    >
                      <div className={showPass ? "eye-slash-icon" : "eye-icon"}></div>
                    </button> */}
                  </div>
                </div>

                {/* Login Button */}
                <button onClick={handleSubmit} className="login-button">
                  Sign In
                </button>

                {/* Forgot Password Link */}
                {/* <div className="forgot-password">
                  <a 
                    href="#" 
                    className="forgot-link"
                  >
                    Forgot your password?
                  </a>
                </div> */}
              </div>
            </div>

            <div className="footer">
              <p className="footer-text">
                © 2025 Vaishnav Samaj. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          html, body {
            height: 100%;
            overflow-x: hidden;
          }

          /* Hide scrollbar for webkit browsers */
          ::-webkit-scrollbar {
            display: none;
          }

          /* Hide scrollbar for IE, Edge and Firefox */
          html {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }

          .login-container {
            height: 100vh;
            display: flex;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            overflow: hidden;
          }

          /* Left Side Styles */
          .left-section {
            display: none;
            position: relative;
            overflow: hidden;
          }

          @media (min-width: 768px) {
            .left-section {
              display: flex;
              width: 45%;
            }
          }

          @media (min-width: 1024px) {
            .left-section {
              width: 50%;
            }
          }

          @media (min-width: 1200px) {
            .left-section {
              width: 55%;
            }
          }

          .animated-bg {
            position: absolute;
            inset: 0;
            background: linear-gradient(135deg, #fb923c 0%, #f97316 0%, #22c55e 0%);
            // animation: pulse 4s ease-in-out infinite;
          }

          .overlay-bg {
            position: absolute;
            inset: 0;
            background: linear-gradient(45deg, rgba(34, 197, 94, 0.3) 0%, rgba(251, 146, 60, 0.3) 50%, rgba(22, 163, 74, 0.3) 100%);
          }

          .floating-element {
            position: absolute;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 50%;
          }

          .floating-1 {
            top: 40px;
            left: 40px;
            width: 80px;
            height: 80px;
            // animation: bounce 2s ease-in-out infinite;
          }

          .floating-2 {
            bottom: 80px;
            right: 80px;
            width: 128px;
            height: 128px;
            // animation: pulse 3s ease-in-out infinite;
          }

          .floating-3 {
            top: 50%;
            right: 40px;
            width: 64px;
            height: 64px;
            // animation: bounce 2s ease-in-out infinite;
            // animation-delay: 1s;
          }

          .left-content {
            position: relative;
            z-index: 10;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            padding: 20px;
            color: white;
            text-align: center;
          }

          @media (min-width: 768px) {
            .left-content {
              padding: 32px;
            }
          }

          @media (min-width: 1024px) {
            .left-content {
              padding: 48px;
            }
          }

          .logo-container {
            margin-bottom: 16px;
            padding: 16px;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 50%;
            backdrop-filter: blur(8px);
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
          }

          @media (min-width: 768px) {
            .logo-container {
              margin-bottom: 24px;
              padding: 20px;
            }
          }

          @media (min-width: 1024px) {
            .logo-container {
              margin-bottom: 32px;
              padding: 24px;
            }
          }

          .logo-img {
            width: 80px;
            height: 80px;
            object-fit: contain;
            filter: drop-shadow(0 25px 25px rgba(0, 0, 0, 0.15));
          }

          @media (min-width: 768px) {
            .logo-img {
              width: 100px;
              height: 100px;
            }
          }

          @media (min-width: 1024px) {
            .logo-img {
              width: 128px;
              height: 128px;
            }
          }

          .company-title {
            font-size: 2rem;
            font-weight: 700;
            margin-bottom: 8px;
            text-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
          }

          @media (min-width: 768px) {
            .company-title {
              font-size: 2.5rem;
              margin-bottom: 12px;
            }
          }

          @media (min-width: 1024px) {
            .company-title {
              font-size: 3rem;
              margin-bottom: 16px;
            }
          }

          @media (min-width: 1200px) {
            .company-title {
              font-size: 3.5rem;
            }
          }

          .company-subtitle {
            font-size: 1.25rem;
            font-weight: 600;
            margin-bottom: 16px;
            color: rgba(251, 146, 60, 0.9);
          }

          @media (min-width: 768px) {
            .company-subtitle {
              font-size: 1.5rem;
              margin-bottom: 20px;
            }
          }

          @media (min-width: 1024px) {
            .company-subtitle {
              font-size: 2rem;
              margin-bottom: 24px;
            }
          }

          .tagline {
            font-size: 0.95rem;
            color: rgba(255, 255, 255, 0.9);
            max-width: 300px;
            margin: 0 auto;
            line-height: 1.5;
          }

          @media (min-width: 768px) {
            .tagline {
              font-size: 1rem;
              max-width: 350px;
              line-height: 1.6;
            }
          }

          @media (min-width: 1024px) {
            .tagline {
              font-size: 1.125rem;
              max-width: 384px;
              line-height: 1.75;
            }
          }

          .decorative-line {
            margin-top: 32px;
            width: 96px;
            height: 4px;
            background: linear-gradient(to right, white, rgba(251, 146, 60, 0.8));
            margin-left: auto;
            margin-right: auto;
            border-radius: 9999px;
          }

          /* Right Side Styles */
          .right-section {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 16px;
            background-color: #f9fafb;
            overflow-y: auto;
          }

          @media (min-width: 768px) {
            .right-section {
              width: 55%;
              padding: 24px;
            }
          }

          @media (min-width: 1024px) {
            .right-section {
              width: 50%;
              padding: 32px;
            }
          }

          @media (min-width: 1200px) {
            .right-section {
              width: 45%;
            }
          }

          .form-container {
            width: 100%;
            max-width: 400px;
          }

          @media (min-width: 768px) {
            .form-container {
              max-width: 420px;
            }
          }

          @media (min-width: 1024px) {
            .form-container {
              max-width: 448px;
            }
          }

          .mobile-logo {
            text-align: center;
            margin-bottom: 10px;
            margin-top: 15px;
          }

          @media (min-width: 768px) {
            .mobile-logo {
              display: none;
            }
          }

          .mobile-logo-img {
            width: 80px;
            height: 80px;
            margin: 0 auto 16px;
          }

          .mobile-title {
            font-size: 1.5rem;
            font-weight: 700;
            background: linear-gradient(to right, #f97316, #16a34a);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
          }

          .login-card {
            background: white;
            border-radius: 16px;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
            padding: 24px;
            border: 1px solid #e5e7eb;
          }

          @media (min-width: 768px) {
            .login-card {
              padding: 28px;
            }
          }

          @media (min-width: 1024px) {
            .login-card {
              padding: 32px;
            }
          }

          .card-header {
            text-align: center;
            margin-bottom: 24px;
          }

          @media (min-width: 768px) {
            .card-header {
              margin-bottom: 28px;
            }
          }

          @media (min-width: 1024px) {
            .card-header {
              margin-bottom: 32px;
            }
          }

          .welcome-title {
            font-size: 1.5rem;
            font-weight: 700;
            color: #1f2937;
            margin-bottom: 8px;
          }

          @media (min-width: 768px) {
            .welcome-title {
              font-size: 1.75rem;
            }
          }

          @media (min-width: 1024px) {
            .welcome-title {
              font-size: 1.875rem;
            }
          }

          .header-line {
            width: 64px;
            height: 4px;
            background: linear-gradient(to right, #f97316, #16a34a);
            margin: 0 auto;
            border-radius: 9999px;
          }

          .welcome-subtitle {
            color: #4b5563;
            margin-top: 12px;
          }

          .form-fields {
            display: flex;
            flex-direction: column;
            gap: 20px;
          }

          @media (min-width: 768px) {
            .form-fields {
              gap: 22px;
            }
          }

          @media (min-width: 1024px) {
            .form-fields {
              gap: 24px;
            }
          }

          .field-container {
            position: relative;
          }

          .field-label {
            display: block;
            font-size: 0.875rem;
            font-weight: 600;
            color: #374151;
            margin-bottom: 8px;
          }

          .input-wrapper {
            position: relative;
          }

          .form-input {
            width: 100%;
            padding: 12px 12px 12px 48px;
            border: 1px solid #d1d5db;
            border-radius: 12px;
            background-color: #f9fafb;
            font-size: 16px;
            transition: all 0.2s ease-in-out;
            outline: none;
          }

          .form-input:focus {
            ring: 2px solid #f97316;
            border-color: transparent;
            background-color: white;
            box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
          }

          .input-icon {
            position: absolute;
            left: 16px;
            top: 50%;
            transform: translateY(-50%);
            color: #9ca3af;
            width: 20px;
            height: 20px;
          }

          .password-input {
            padding-right: 48px;
          }

          .toggle-password {
            position: absolute;
            right: 16px;
            top: 50%;
            transform: translateY(-50%);
            color: #9ca3af;
            background: none;
            border: none;
            cursor: pointer;
            padding: 4px;
            transition: color 0.2s ease-in-out;
          }

          .toggle-password:hover {
            color: #4b5563;
          }

          .login-button {
            width: 100%;
            padding: 12px 24px;
            background: linear-gradient(to right, #f97316, #16a34a);
            color: white;
            font-weight: 700;
            border-radius: 12px;
            box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
            border: none;
            cursor: pointer;
            font-size: 16px;
            transition: all 0.2s ease-in-out;
          }

          .login-button:hover {
            background: linear-gradient(to right, #ea580c, #15803d);
            transform: scale(1.02);
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
          }

          .login-button:focus {
            outline: none;
            box-shadow: 0 0 0 4px rgba(249, 115, 22, 0.5);
          }

          .forgot-password {
            text-align: center;
          }

          .forgot-link {
            font-size: 0.875rem;
            color: #4b5563;
            text-decoration: none;
            font-weight: 500;
            transition: color 0.2s ease-in-out;
          }

          .forgot-link:hover {
            color: #f97316;
          }

          .footer {
            text-align: center;
            margin-top: 20px;
          }

          @media (min-width: 768px) {
            .footer {
              margin-top: 24px;
            }
          }

          @media (min-width: 1024px) {
            .footer {
              margin-top: 32px;
            }
          }

          .footer-text {
            font-size: 0.875rem;
            color: #6b7280;
          }

          /* Animations */
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.8;
            }
          }

          @keyframes bounce {
            0%, 100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-10px);
            }
          }

          /* Icon styles */
          .user-icon::before {
            content: "👤";
            font-size: 20px;
          }

          .lock-icon::before {
            content: "🔒";
            font-size: 18px;
          }

          .eye-icon::before {
            content: "👁️";
            font-size: 18px;
          }

          .eye-slash-icon::before {
            content: "🙈";
            font-size: 18px;
          }
        `}
      </style>
    </>
  );
}
